import * as React from 'react';

const SpinnerSvg = ({ className = 'spinner' }: { className?: string }) => (
  <svg aria-label="Loading spinner" className={className} role="img" viewBox="0 0 50 50">
    <circle cx="25" cy="25" r="20" />
  </svg>
)

const Spinner = () => (
  <div className="loading-spinner">
    <div className="spinner-container">
      <SpinnerSvg />
    </div>
  </div>
)

export { Spinner, SpinnerSvg };
